import Link from 'next/link'

import info from '../Info'
import outOfStock from '../OutOfStock'

import styles from '../styles.module.css'

export default function layout(props) {
  const {href, productsLayout, image, parentProps, className, onClick} = props
  return productsLayout === 'compact' ? (
    <Link href={href} scroll={false}>
      <a className={className.join(' ')} onClick={onClick}>
        {outOfStock(parentProps)}
        <div className={styles.img}>{image}</div>
        {info(parentProps)}
      </a>
    </Link>
  ) : (
    <Link href={href} scroll={false}>
      <a className={className.join(' ')} onClick={onClick}>
        {outOfStock(parentProps)}
        {info(parentProps)}
        <div className={styles.img}>{image}</div>
      </a>
    </Link>
  )
}
